import React, { useEffect, useRef } from "react"
import { useFrame, useLoader, useThree, extend } from "@react-three/fiber"
import { useGLTF, shaderMaterial } from '@react-three/drei'
import { PLYLoader } from "three-stdlib"
import * as THREE from 'three'

class ColorShiftMaterial extends THREE.ShaderMaterial {
  constructor() {
    super({

      uniforms: { time: { value: 0 }},
      // vertex shader
      vertexShader: `
    varying vec2 vUv;
    varying vec3 vColor;


    uniform float time;
    varying float vDistance;

    void main() {
      vUv = uv;
      vColor = color;
      vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
      gl_Position = projectionMatrix * mvPosition;
      gl_PointSize = 3.0 + 2.0 * sin(time/1.5);
      // gl_PointSize = 9.0 + 8.0 * sin(time/1.5);
      gl_PointSize =  min(gl_PointSize * (5.0 / - mvPosition.z), 10.0);



      // vec3 myvertex = vec3(projectionMatrix * gl_Position);
      vDistance = length(position);
    }
  `,
      // fragment shader
      fragmentShader: `
    // in vec3 vColor;

    uniform float time;
    uniform sampler2D tDepth;
		uniform float cameraNear;
		uniform float cameraFar;

    varying vec2 vUv;
    varying vec3 vColor; 
		
    varying float vDistance;


    void main() {
      float ndcz = gl_FragCoord.z / gl_FragCoord.w;
      float depth = ndcz * 0.5 + 0.5;

      // float depth = getDepth( vUv );
      // gl_FragColor.rgba = vec4(0.5 + 0.3 * sin(vUv.yxx + time) + vColor, 1.0);
      gl_FragColor.rgb = vColor;
      // gl_FragColor.a = 0.5 + sin(time * vDistance / 10.0);

      gl_FragColor.rgb = gl_FragColor.rgb * (1.0 + 1.0*smoothstep(0.99,1.0,sin(8.0*vDistance + 1.0*time)));
    }
  `,
      vertexColors: true
    })
  }
}

extend({ ColorShiftMaterial })

    export default function Room(props) {
  const pointCloud = useLoader(PLYLoader, 'public\giovanni_paolo_panini-statues_in_a_ruined_arcade-final.ply')

  const scene = useThree(state => state.scene)
  // const material = new ColorShiftMaterial({ vertexColors: true })
  // const mesh = new THREE.Points(pointCloud, material);

  const time = useRef(0)

  const material = useRef()

  useFrame((state, delta) => {
    time.current += delta
    material.current.uniforms.time.value = time.current
    // material.com
    material.current.needsUpdate = true
    // console.log(material.uniforms)
  })


  // useEffect(() => {
  //   scene.add(mesh)
  // }, [])

  return (
  <group position={[0,1,0]}>
    <points>
      <primitive object={pointCloud} attach="geometry" />
      <colorShiftMaterial attach="material" vertexColors={true} ref={material} />
    </points>
  </group>
  )
}